module.exports = __webpack_public_path__ + "media/images/greenhouse-logo-43238e35b25d864dacdece85e2467d36.jpg";